

const Revenue = () => {
    return (
        <div>
            <h1>Revenue</h1>
        </div>
    );
}
export default Revenue;